// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"Media_imgContainer__27mGV","img":"Media_img__1Z0oc"};